import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const questions = [
  'question_1', 'question_2', 'question_3', 'question_4',
  'question_5', 'question_6', 'question_7', 'question_8',
];

export default function QuestionsAPoser() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="questions" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('questions_h2')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {questions.map((q, idx) => (
          <div
            key={idx}
            className={`flex gap-3 bg-soft-gray rounded-lg p-4 md:p-5 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 80 + 150}ms` }}
          >
            <div className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-copper text-white font-bold text-xs">
              {idx + 1}
            </div>
            <p className="text-slate-primary/80 text-sm md:text-base leading-relaxed">{t(q)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}